import { Button } from '../Button/Button';
import IconButton from '../IconButton/IconButton';
import { Actions, Close, Content, Wrapper } from './WarningBar.style';

export type WarningBarProps = {
  onCta: () => void;
  onCancel: () => void;
};

export function WarningBar(props: WarningBarProps) {
  return (
    <Wrapper className='WarningBar-wrapper' data-testid='WarningBar-wrapper'>
      <Content>
        Any changes you make in the playground are NOT permanent. Click "Save Model" to choose a
        project to save your changes to.
        <Actions>
          <Button onClick={props.onCta} color='#94852f'>
            Got it
          </Button>
        </Actions>
      </Content>
      <Close>
        <IconButton name='IconX' color='#333' onClick={props.onCancel} />
      </Close>
    </Wrapper>
  );
}

export default WarningBar;
